<div class="card mb-3 print-c"
    [ngClass]="{ 
                 'card-theme': status=='' || status==0 || status=='theme', 
                 'card-success': status == 1, 
                 'card-warning': status > 1 && status <= 3, 
                 'card-danger': status > 3 
                }">
    <div class="card-header">
      <div class="card-title-icon"></div>
      <h2 class="text-uppercase card-title">{{titulo}}</h2>
    </div>
    <div class="card-body p-0">
        <ng-content></ng-content>
    </div>
  </div>
